import css from 'styled-jsx/css';

export const returnPolicyContentStyles = css`
  /* Container principal */
  .return-policy-content {
    max-width: 100%;
    font-family: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
    color: #333333;
  }

  /* Secciones */
  .return-policy-section {
    margin-bottom: 2rem;
  }

  .return-policy-section:last-child {
    margin-bottom: 0;
  }

  /* Párrafos base */
  .policy-paragraph {
    margin: 0 0 1rem 0;
    text-align: justify;
    font-size: 14px;
    line-height: 1.6;
    color: #333333;
  }

  /* Párrafos primarios */
  .policy-paragraph--primary,
  .policy-paragraph--primary-legacy,
  .policy-paragraph--primary-new {
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 1.25rem;
  }

  .policy-paragraph--primary-old {
    font-weight: 400;
    color: #555555;
  }

  .policy-paragraph--with-top-margin {
    margin-top: 1.5rem;
  }

  /* Párrafos secundarios */
  .policy-paragraph--secondary,
  .policy-paragraph--secondary-legacy,
  .policy-paragraph--secondary-new {
    font-size: 14px;
    margin-bottom: 1rem;
  }

  /* Párrafos terciarios */
  .policy-paragraph--tertiary-new {
    font-size: 13px;
    color: #666666;
    margin-bottom: 0.75rem;
  }

  /* Wrappers de párrafos */
  .paragraph-wrapper {
    margin-bottom: 0.5rem;
  }

  .paragraph-wrapper--centered {
    text-align: center;
  }

  .paragraph-wrapper--centered .policy-paragraph {
    text-align: center;
  }

  /* Iconos */
  .policy-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 0.5rem;
    vertical-align: text-top;
    background-color: #666666;
    border-radius: 2px;
  }

  /* Listas */
  .policy-list {
    margin: 1rem 0 !important;
    padding-left: 1.25rem !important;
    list-style-type: disc !important;
    font-family: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
    background-color: #f0f8ff !important;
    display: block !important;
    visibility: visible !important;
  }

  .policy-list--no-top-padding {
    margin-top: 0;
  }

  .policy-list--modern-padding {
    padding-left: 1.5rem;
  }

  .policy-list__item {
    margin-bottom: 0.5rem;
    text-align: justify;
    font-size: 14px;
    line-height: 1.5;
    color: #333333;
  }

  .policy-list__item:last-child {
    margin-bottom: 0;
  }

  /* Divisores */
  .policy-divider {
    width: 100%;
    height: 1px;
    background-color: #e5e5e5;
    margin: 1.5rem 0;
    border: none;
  }

  .policy-divider--section {
    margin: 2rem 0;
  }

  .policy-divider--paragraph {
    margin: 1rem 0;
  }

  /* Responsive para móvil */
  @media (max-width: 767px) {
    .return-policy-content {
      font-size: 13px;
    }

    .policy-paragraph--primary,
    .policy-paragraph--primary-legacy,
    .policy-paragraph--primary-new {
      font-size: 14px;
    }

    .policy-paragraph {
      font-size: 13px;
    }

    .policy-list__item {
      font-size: 13px;
    }

    .return-policy-section {
      margin-bottom: 1.5rem;
    }

    .policy-list {
      padding-left: 1rem;
    }
  }

  /* Responsive para tablet */
  @media (min-width: 768px) and (max-width: 1023px) {
    .policy-paragraph--primary,
    .policy-paragraph--primary-legacy,
    .policy-paragraph--primary-new {
      font-size: 15px;
    }

    .policy-paragraph {
      font-size: 14px;
    }
  }
`;

/**
 * Additional utility styles for enhanced UX
 */
export const enhancedStyles = {
  scrollBehavior: 'smooth',

  focusRing: {
    outline: '2px solid #3b82f6',
    outlineOffset: '2px',
    borderRadius: '4px',
  },

  transitions: {
    fast: '0.15s ease-out',
    normal: '0.2s ease-in-out',
    slow: '0.3s ease-in-out',
  },
};

/**
 * CSS Class mappings for BEM convention
 * Maps original classes to new symbolic BEM classes
 */
export const cssClasses = {
  // Container classes
  container: 'return-policy-content',
  section: 'return-policy-section',

  // Paragraph classes
  paragraph: {
    base: 'policy-paragraph',
    primary: 'policy-paragraph--primary',
    primaryLegacy: 'policy-paragraph--primary-legacy', // p-1
    primaryNew: 'policy-paragraph--primary-new', // p1-new
    primaryOld: 'policy-paragraph--primary-old', // old
    secondary: 'policy-paragraph--secondary',
    secondaryLegacy: 'policy-paragraph--secondary-legacy', // p-2
    secondaryNew: 'policy-paragraph--secondary-new', // p2-new
    tertiaryNew: 'policy-paragraph--tertiary-new', // p2-new for tertiary
    withTopMargin: 'policy-paragraph--with-top-margin', // margin-top-11
  },

  // Wrapper classes
  wrapper: {
    base: 'paragraph-wrapper',
    centered: 'paragraph-wrapper--centered', // center
  },

  // Icon classes
  icon: {
    base: 'policy-icon', // no-refund-icon
  },

  // List classes
  list: {
    base: 'policy-list',
    modernPadding: 'policy-list--modern-padding', // new-ul-padding
    noTopPadding: 'policy-list--no-top-padding', // padding-top-0
    item: 'policy-list__item',
  },

  // Divider classes
  divider: {
    base: 'policy-divider', // divider-line
    section: 'policy-divider--section',
    paragraph: 'policy-divider--paragraph',
  },
};
